import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import detractionBasicInformationPropTypes from '../proptypes/GeneralIncomeTypePropTypes';

const GeneralIncomeTypeBasicInformationResource = ({
  name,
  description,
  expenseCode,
  generalIncomeTypeLabel
}) => (
  <>
      <ResourceProperty label="Nombre:">{name}</ResourceProperty>
      <ResourceProperty label="Descripción:">{description}</ResourceProperty>
      <ResourceProperty label="Código de egreso:">{expenseCode}</ResourceProperty>
      <ResourceProperty label="Clase de Tipo de Ingreso:">{generalIncomeTypeLabel}</ResourceProperty>
  </>
);

GeneralIncomeTypeBasicInformationResource.propTypes =
  detractionBasicInformationPropTypes;

export default GeneralIncomeTypeBasicInformationResource;
